<template>
  <div class="performance-kpis">
    <div class="kpi-row">
      <div v-for="(kpi, index) in kpiTypes"
           :class="['kpi-wrapper', kpi.class]"
           :key="index">
        <tooltip v-if="kpiData[kpi].title === 'roi'"
                 position="top"
                 class="kpi-tooltip">
          <div slot="content" class="tooltip-content">
            <h6 class="tooltip-header">
              ROI calculation
            </h6>
            <h6>(sales - cost)</h6>
            <hr>
            <h6>cost</h6>
          </div>
          <sup v-if="kpiData[kpi].title === 'roi'" class="prompt">i</sup>
        </tooltip>

        <kpi-block
          :retailerIds="retailerIds"
          :apiParams="apiParams"
          :calculatedData="getCalculatedData(kpi)"
          :currency="kpiData[kpi].currency"
          :kpiKey="kpi"
          :percentage="kpiData[kpi].percentage"
          :shouldSendBack="performanceValuesReturned.includes(kpi)"
          :title="kpiData[kpi].title"
          :url="calculatedKpis.includes(kpi) ? null : `/performance/${kpi}`"
          wrapperClasses="dashboard-kpis"
          @setKpiValue="setKpiValue" />
      </div>
    </div>
  </div>
</template>

<script>
  import KpiBlock from '../KpiData/KpiBlock.vue'
  import { NumberFormatters } from '../mixins/NumberFormatters.js'
  import Tooltip from '../Shared/Tooltip'

  export default {
    props: {
      apiParams: Object,
      smsRate: Number,
      retailerIds: Array
    },

    name: 'PerformanceKpis',

    components: {
      KpiBlock,
      Tooltip
    },

    mixins: [NumberFormatters],

    data() {
      return {
        calculatedKpis: ['total_cost','roi'],
        messages_sent: null,
        kpiData: null,
        performanceValuesReturned: ['messages_remaining', 'messages_sent','revenue_generated'],
        kpiTypes: ['messages_remaining', 'messages_sent','retailers_sent','purchases', 'total_units', 'revenue_generated','total_cost','roi'],
        revenue_generated: null,
      }
    },

    methods: {
      buildKpiDefaultObject(objectKey, extraKeyIsTrue) {
        let kpi = {
          loading: true,
          title: objectKey.replace(/_/g, ' '),
          value: null
        }
        if (extraKeyIsTrue) { kpi[extraKeyIsTrue] = true }
        return kpi
      },

      configureKpis() {
        const currencyKpis = ['revenue_generated','total_cost'],
          percentageKpis = ['roi']
        let kpis = {}
        this.kpiTypes.forEach(kpi => {
          let isCurrency = currencyKpis.includes(kpi),
            isPercentage = percentageKpis.includes(kpi),
            extraKeyIsTrue = isCurrency ? 'currency' : isPercentage ? 'percentage' : null
          return kpis[kpi] = this.buildKpiDefaultObject(kpi, extraKeyIsTrue)
        })
        this.kpiData = kpis
      },

      getCalculatedData(kpi) {
        if (this.calculatedKpis.includes(kpi)) {
          return kpi === 'roi' ? this.roi : this.totalCost
        } else {
          return null
        }
      },

      setKpiValue(kpiKey, kpiValue) {
        this[kpiKey] = kpiValue
      },
    },

    created() {
      this.configureKpis()
    },

    computed: {
      roi: function() {
        const calcRoi = Math.round((this.revenue_generated - this.removeCommas(this.totalCost)) / this.removeCommas(this.totalCost) * 100)
        return this.revenue_generated <= this.removeCommas(this.totalCost) ? 0 : this.numberWithCommas(calcRoi)
      },

      totalCost: function() {
        const costCalc = this.messages_sent ? this.messages_sent * this.smsRate : 0
        return this.numberWithCommas(costCalc.toFixed(2))
      },
    },
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.performance-kpis
  color: $title-color
  .kpi-row
    margin: 2rem auto
    display: flex
    justify-content: space-around

  .kpi-wrapper
    border-right: none
    &:last-child
      border-right: none
      position: relative
      bottom: 18px

  .kpi-title
    font-size: 1.15rem
    margin-bottom: .25rem

  .kpi-data
    font-size: 1.15rem

.kpi-row
  display: flex
  justify-content: center
  max-width: 1000px
  margin: auto

.kpi-wrapper
  border-right: 1px solid #deeefe
  flex-basis: 25%
  padding: 0 .5rem
  text-align: center

  .lift
    color: #3adb76
    font-family: "AileronLight"

    &.negative
      color: $negative-hover

.divider
  border-top: 1px solid #deeefe
  display: block
  margin: .75rem auto
  padding-left: 0px
  width: 60%

.kpi-tooltip
  .tooltip-header
    margin-bottom: 10px
    font-weight: bolder

  .tooltip-text
    font-size: 14px
    bottom: 10px
    margin: 0 -2em
    width: max-content
    left: 51%
    transform: translateX(-16%)


.prompt
  color: $primary-color
  border: 1px solid $primary-color
  border-radius: 50%
  padding: 0 6px 0 8px
  display: inline-flex
  cursor: pointer
  position: relative
  left: 10px
  top: 18px

</style>
